import axiosInstance from "../interceptor/interceptor"; // Assuming axiosInstance is correctly configured
import dictionary from "../dictionary";

const { profile } = dictionary;

const userProfileServices = {
  changeUserPassword: (userId: number, body: any) =>
    axiosInstance.put(profile.changeUserPassword(userId), body),
  getProfileDetails: (payload: any) =>
    axiosInstance.post(profile.getProfileDetails(), payload),
  deactivateUser: () =>
    axiosInstance.post(profile.deactivateUser()),
};

export default userProfileServices;
